export const keys = <T extends object>(obj: T): (keyof T)[] =>
  Object.keys(obj) as (keyof T)[]

/**
 * Safely access a property from an object that may have private or undefined fields.
 */
export function getPropertyOrUndefined<T extends object>(
  provider: T | undefined,
  property: string,
): unknown {
  try {
    return (provider as Record<PropertyKey, unknown> | undefined)?.[property]
  } catch {
    return undefined
  }
}
